import React from 'react'

export function PencilSolidIcon() {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none">
      <path d="M9.99792 2.67019L13.2686 5.94086L4.98957 14.2199L1.72073 10.9492L9.99792 2.67019ZM15.7505 1.88138L14.2918 0.422776C13.7281 -0.140925 12.8128 -0.140925 12.2472 0.422776L10.85 1.81998L14.1207 5.09068L15.7505 3.46092C16.1877 3.02368 16.1877 2.31859 15.7505 1.88138ZM0.00910159 15.5464C-0.050421 15.8143 0.191439 16.0544 0.459351 15.9892L4.104 15.1055L0.835152 11.8348L0.00910159 15.5464Z" fill="#6C757D"/>
    </svg>
  )
}